import React, { useEffect } from 'react';
import './PoliticaComponent.css';

export const PoliticaComponent = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='politica-container'>
        <h1 className='titulo-page'>{props.I18n.PrivacyPolicies}</h1>
        <ul>
            <li>
        <p>{props.I18n.PrivacyPolicyP1}</p>
            </li>
        </ul>
        <h2>{props.I18n.InformationGathering}</h2>
        <ul>
            <li>
            <p>{props.I18n.PrivacyPolicyP2}</p>
            </li>
            <li>
            <p>{props.I18n.PrivacyPolicyP3}</p>                
            </li>
        </ul>
        <h2>{props.I18n.UseOfInformation}</h2>
        <ul>
            <li>
            <p>{props.I18n.PrivacyPolicyP4}</p>
            </li>
            <li>
            <p>{props.I18n.PrivacyPolicyP5}</p>
            </li>
            <li>
                <p>{props.I18n.PrivacyPolicyP6}</p>
            </li>
        </ul>
        <h2>{props.I18n.InformationProtection}</h2>
        <ul>
            <li>
            <p>{props.I18n.PrivacyPolicyP7}</p>
            </li>
            <li>
            <p>{props.I18n.PrivacyPolicyP8}</p>
            </li>
        </ul>
        <h2>{props.I18n.AccessAndControlOfInformation}</h2>
        <ul>
            <li>
            <p>{props.I18n.PrivacyPolicyP9}</p>
            </li>
            <li>
            <p>{props.I18n.PrivacyPolicyP10}</p>
            </li>
        </ul>
        <h2>{props.I18n.ChangesToThePrivacyPolicy}</h2>
        <ul>
            <li>
            <p>{props.I18n.PrivacyPolicyP11}</p>
            </li>
            <li>
            <p>{props.I18n.PrivacyPolicyP12}</p>
            </li>
        </ul>
        <p>{props.I18n.PrivacyPolicyP13}</p>
        <p>{props.I18n.PrivacyPolicyP14} <b>{props.I18n.FallaEmail}</b></p>
        <p>{props.I18n.PrivacyPolicyP15}</p>
    </div>

  );
}
